module.exports = __webpack_public_path__ + "static/media/student.1fa988ad.png";